import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../shared/redux-store/store";
import {SessionActions} from "../shared/actions/session.actions";
import {BarcodeService} from "../identity/services/barcode.service";
import {AbstractVisbosComponent} from "../core/visbos-core/components/abstract-visbos.component";
import {AdminUnitActions} from "../shared/actions/admin-unit.actions";
import {WithdrawalActions} from '../store-management/redux/scans.actions';

@Component({
  selector: 'vb-visbos-touch-client',
  templateUrl: './visbos-touch-client.component.html',
  styleUrls: ['./visbos-touch-client.component.css']
})
export class VisbosTouchClientComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              public ngRx: NgRedux<IAppState>, private bcService: BarcodeService,
              private adminUnitActions: AdminUnitActions, private withdrawalActions: WithdrawalActions) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    this.withdrawalActions.finishWithdrawalsTransaction();
    this.addSubscription(this.bcService.cacheBarcodes().subscribe());
    this.addSubscription(this.sessionActions.fetchAuthorizedUser(this.ngRx.getState().session.token).subscribe());
    this.addSubscription(this.adminUnitActions.retrieveAdminUnitData(this.activeAdminUnitCuid$).subscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/visbos-touch-client.component.ts